import React from "react";
import { useSelector } from "react-redux";
import { ArrowLeftIcon, Body1, Dialog, IconButton } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getFeatureFlag } from "~/store/selectors/selector.featureFlags";
import { assets_url } from "~/utils/urls";

export const GettingStartedDialog = ({
  open,
  onClose,
  children,
  fullDialogWidth,
  dialogClassName,
  leftSideClassName,
  rightSideClassName,
  backButtonClassname,
  showBackButton,
  onBackButtonClick,
  dialogTitle,
  featureExplainerTitle,
  featureExplainerContent,
  testimonialImageUrl,
  testimonialImageAlt,
  testimonialContent,
}) => {
  const showTestimonials = useSelector((state) => !getFeatureFlag(state, "why_this_matters_off"));
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classNames("tw-overflow-auto", fullDialogWidth)}
    >
      <div
        className={classNames(
          "tw-flex tw-flex-col-reverse lg:tw-flex-row tw-w-full tw-justify-between tw-relative",
          dialogClassName
        )}
      >
        <div className={classNames("tw-flex tw-flex-col tw-w-full tw-relative", leftSideClassName)}>
          <div className={classNames("tw-flex tw-items-center tw-my-4 sm:tw-mb-5 lg:tw-mb-8", backButtonClassname)}>
            {showBackButton ? (
              <IconButton
                variant="text gray"
                onClick={onBackButtonClick}
                className="tw-mr-[2px]"
              >
                <ArrowLeftIcon />
              </IconButton>
            ) : null}
            <Body1 weight="bold">{dialogTitle}</Body1>
          </div>
          <div>{children}</div>
        </div>
        {showTestimonials ? (
          <div
            className={classNames(
              "tw-bg-primary-200 tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-flex-grow-0",
              rightSideClassName
            )}
          >
            <div className="tw-hidden lg:tw-block">
              <Body1 weight="bold">{featureExplainerTitle}</Body1>
              {featureExplainerContent}
              <Dialog.ContentDivider className="tw-my-8" />
            </div>
            <div className="tw-flex tw-gap-4">
              <img
                src={`${assets_url}/${testimonialImageUrl}`}
                alt={testimonialImageAlt}
                className="tw-w-16 tw-h-16 tw-rounded-full tw-bg-theme-400 tw-shrink-0"
              />
              <div>{testimonialContent}</div>
            </div>
          </div>
        ) : null}
      </div>
    </Dialog>
  );
};

GettingStartedDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.any,
  fullDialogWidth: PropTypes.string,
  dialogClassName: PropTypes.string,
  leftSideClassName: PropTypes.string,
  rightSideClassName: PropTypes.string,
  backButtonClassname: PropTypes.object,
  showBackButton: PropTypes.bool,
  onBackButtonClick: PropTypes.func,
  dialogTitle: PropTypes.string,
  featureExplainerTitle: PropTypes.string,
  featureExplainerContent: PropTypes.node, // ???
  testimonialImageUrl: PropTypes.string,
  testimonialImageAlt: PropTypes.string,
  testimonialContent: PropTypes.node, // ??
};
